import { AddressSuggestion, BaseAddress } from './checkoutState';
import { config } from './config';
import { Country } from './countryData';

export const getStreetHouseNumberFormat = (country: Country) =>
  config.addressForm[country].streetHouseNumber.houseNumber.position === 'second'
    ? /^(?<street>[a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF\u0100-\u024F\-. '\u2018-\u2019\u0600-\u06FF\u0590-\u05FF\u0400-\u04FF]*[a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF\u0100-\u024F.\u0600-\u06FF\u0590-\u05FF\u0400-\u04FF]),? (?<houseNumber>(?<normalizedHouseNumber>\d+)[-/]?(\d+)?([a-z]+)?)$/i
    : /^(?<houseNumber>(?<normalizedHouseNumber>\d+)[-/]?(\d+)?([a-z])?),? (?<street>[a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF\u0100-\u024F\-. '\u2018-\u2019\u0600-\u06FF\u0590-\u05FF\u0400-\u04FF]*[a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF\u0100-\u024F.\u0600-\u06FF\u0590-\u05FF\u0400-\u04FF])$/i;

export const splitStreetHouseNumber = (streetHouseNumberInput: string, country: Country) => {
  const streetHouseNumberParts = getStreetHouseNumberFormat(country).exec(streetHouseNumberInput)?.groups;
  return { street: streetHouseNumberParts?.street ?? '', houseNumber: streetHouseNumberParts?.houseNumber ?? '' };
};

export const joinStreetHouseNumber = ({
  country,
  street,
  houseNumber,
}: Pick<BaseAddress, 'country' | 'street' | 'houseNumber'>) =>
  config.addressForm[country.iso2Code].streetHouseNumber.houseNumber.position === 'second'
    ? `${street} ${houseNumber}`
    : `${houseNumber} ${street}`;

export const joinZipCodeCity = ({ country, zipCode, city }: Pick<BaseAddress, 'country' | 'zipCode' | 'city'>) => {
  if (!zipCode) {
    return city;
  }
  return config.addressForm[country.iso2Code].zipCodeCity.zipCode.position === 'first'
    ? `${zipCode} ${city}`
    : `${city} ${zipCode}`;
};

export const getAddressForSubmission = (addressValues: any & { streetHouseNumber: string }) => {
  if (config.addressForm[addressValues.country].streetHouseNumber.separateFields) {
    return {
      country: { iso2Code: addressValues.country },
      gender: addressValues.gender,
      firstName: addressValues.firstName,
      lastName: addressValues.lastName,
      street: addressValues.street.trim(),
      houseNumber: addressValues.houseNumber.trim(),
      additional: addressValues.additional || undefined,
      zipCode: addressValues.zipCode || undefined,
      city: addressValues.city,
      state: addressValues.state || undefined,
      signature: addressValues.signature,
    };
  } else {
    const { street, houseNumber } = splitStreetHouseNumber(addressValues.streetHouseNumber, addressValues.country);
    return {
      country: { iso2Code: addressValues.country },
      gender: addressValues.gender,
      firstName: addressValues.firstName,
      lastName: addressValues.lastName,
      street,
      houseNumber,
      additional: addressValues.additional || undefined,
      zipCode: addressValues.zipCode || undefined,
      city: addressValues.city,
      state: addressValues.state || undefined,
      signature: addressValues.signature,
    };
  }
};

export const getInitialAddressValues = (address: BaseAddress & Partial<AddressSuggestion>) => ({
  country: address.country.iso2Code,
  gender: address.salutationCode,
  title: address.title ?? '',
  firstName: address.firstName,
  lastName: address.lastName,
  street: address.street,
  houseNumber: address.houseNumber,
  streetHouseNumber: joinStreetHouseNumber(address),
  additional: address.additional ?? '',
  zipCode: address.zipCode ?? '',
  city: address.city,
  state: address.state ?? '',
  signature: address.signature,
});
